import type { InjectionToken, Provider } from '@angular/core';

import type { EnvironmentRepository, RepositoryConfiguration } from '@contexts/shared/domain';
import { RepositoryNotFoundError } from '@contexts/shared/domain/errors';

import { ENVIRONMENT_REPOSITORY } from '@dependencies/shared';

export function repositoryFactoryBuilder<Repository>(
	repositoryKey: string,
	provide: InjectionToken<unknown>,
	repositoryConfig: RepositoryConfiguration<Repository>
): Provider {
	const useFactory = (environment: EnvironmentRepository, ...deps: unknown[]) => {
		const selectedRepositoryType = environment.repositories[repositoryKey];

		if (!selectedRepositoryType) {
			throw new RepositoryNotFoundError(`Repository "${repositoryKey}" not found.`);
		}

		const repositoryDefinition = repositoryConfig[selectedRepositoryType];

		if (!repositoryDefinition) {
			throw new RepositoryNotFoundError(
				`No configuration found for repository type "${selectedRepositoryType}"`
			);
		}

		return repositoryDefinition.factory(...(deps as never[]));
	};

	return {
		provide,
		useFactory,
		deps: [
			ENVIRONMENT_REPOSITORY,
			...Object.values(repositoryConfig).flatMap((config) => config.deps)
		]
	};
}
